module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "hrms-dropdown-year"
    }
  }, [_c('hrms-dropdown', {
    attrs: {
      "options": _vm.objYear[_vm.nowLang],
      "disabled": _vm.disabled,
      "showNone": false
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ecd64e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrmsDropdownYear/component.vue
// module id = 3746
// module chunks = 1